import { defineMessages } from 'react-intl';

const enumMessages = defineMessages({
    cardForegroundAltText: {
        id: 'cardAltText.FOREGROUND_ALT_TEXT',
        defaultMessage: 'Card logo foreground',
    },
    cardBackgroundAltText: {
        id: 'cardAltText.BACKGROUND_ALT_TEXT',
        defaultMessage: 'Card logo background',
    },
});

export default enumMessages;
